<template>
  <div>

    <!-- BODY -->
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <!-- Form -->
      <b-form
        class="p-2"
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          size="sm"
          @click="addNewData"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-25"
          />
          <span>{{ $t('Yeni Depo') }}</span>
        </b-button>
        <hr>
        <!-- Row Loop -->
        <b-row>
          <b-col md="7">
            <span>{{ $t('Depo İsmi') }}</span>
          </b-col>

          <b-col md="5" />
        </b-row>
        <b-row><b-col md="12" /></b-row>
        <b-row
          v-for="(item, index) in storesData"
          :id="item.id"
          :key="item.id"
          ref="row"
        >

          <!-- Item Name -->
          <b-col md="2">
            <b-form-group>
              <b-form-input
                id="item-name"
                v-model="item.name"
                type="text"
                :placeholder="$t('Depo İsmi Giriniz')"
                :readonly="item.creator!=1"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <b-form-input
                id="item-description"
                v-model="item.description"
                type="text"
                :placeholder="$t('Depo Açıklaması')"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group>
              <b-form-input
                id="item-email"
                v-model="item.email"
                type="text"
                :placeholder="$t('E-Posta Adresi')"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="item.product_count>0"
            md="2"
            class="mb-50"
          >
            <b-badge
              variant="info"
              class="badge-round"
            >
              {{ $t('Bu Depoya Ürünler Bağlı !') }}
            </b-badge>
          </b-col>
          <b-col
            v-if="item.creator!=1"
            md="2"
            class="mb-50"
          >
            <b-badge
              v-if="item.creator==2"
              variant="info"
              class="badge-round"
            >
              {{ $t('Otomatik Oluşturulan') }}
            </b-badge>
          </b-col>
          <b-col
            v-if="item.creator!=1"
            md="1"
            class="mb-50"
          >
            <b-form-group>
              <b-form-checkbox
                v-model="item.is_commercial"
                class="custom-control-primary"
                name="check-button"
                :value="1"
                :unchecked-value="0"
              >
                {{ $t('Ticari Depo') }}
              </b-form-checkbox>

            </b-form-group>
          </b-col>

          <b-col
            v-if="item.creator==1 && item.product_count<=0"
            md="2"
            class="mb-50"
          >

            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-danger"
              size="sm"
              @click="deleteData(index)"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span>{{ $t('Sil') }}</span>
            </b-button>
          </b-col>
          <b-col

            md="2"
            class="mb-50"
          >
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="primary"
              size="sm"
              @click="saveData(index)"
            >
              <feather-icon
                icon="SaveIcon"
                class="mr-25"
              />
              <span>{{ $t('Kaydet') }}</span>
            </b-button>
          </b-col>

        </b-row>

      </b-form>
      <b-alert
        variant="warning"
        show
      >
        <div class="alert-body">
          <span>{{ $t('Sistem Tarafından Otomatik Oluşturulan Veriler Düzenlenemez ve Silinemez') }}</span>
        </div>
      </b-alert>
      <b-alert
        variant="warning"
        show
      >
        <div class="alert-body">
          <span>{{ $t('Herhangibir ürüne bağlı olan depo tanımları silinemez. Silebilmek için önce bağlı olduğu ürünü siliniz veya üründen tanımlı vergiyi kaldırınız.') }}</span>
        </div>
      </b-alert>
    </validation-observer>

  </div>
</template>

<script>
import {
  BForm, BFormGroup, VBModal, BAlert, BFormInput, BButton, BRow, BCol, BBadge, BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'

export default {
  components: {
    BForm,
    BAlert,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BButton,
    ValidationObserver,
    BCol,
    BBadge,
    BRow,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  model: {
    prop: 'isEditCustomerSidebarActive',
    event: 'update:is-edit-customer-sidebar-active',
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      countries,
      blankStoreData: {
        name: '',
        email: '',
        creator: 1,
        description: '',
      },
      storesData: [],
      dataFetched: false,
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.fetchData()
      } else if (this.dataFetched) {
        this.$emit('dataChanged', this.storesData)
      }
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    deleteData(index) {
      const selectedData = this.storesData[index]
      this.$swal({
        title: this.$t('Emin Misiniz ?'),
        text: this.$t('Bu depo Silindiğinde depoya bağlı Olan ürün verileri bozulabilir.'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Silme İşlemini Onayla'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('app-product/deleteStore', { id: selectedData.id })
            .then(() => {
              if (index > -1) {
                this.storesData.splice(index, 1)
              }
              this.showSuccessMessage()
            })
            .catch(() => {
              this.showErrorMessage()
            })
        }
      })
    },
    showSuccessMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarılı'), {
        title: this.$t('İşlem Başarılı'),
        variant: 'success',
        solid: false,
      })
    },
    showErrorMessage() {
      this.$bvToast.toast(this.$t('İşlem Başarısız'), {
        title: this.$t('İşlem Başarısız'),
        variant: 'danger',
        solid: false,
      })
    },
    saveData(index) {
      const selectedData = this.storesData[index]
      store.dispatch('app-product/updateStore', selectedData)
        .then(() => {
          this.showSuccessMessage()
        })
        .catch(() => {
          this.showErrorMessage()
        })
    },
    addNewData() {
      store.dispatch('app-product/addStore', {})
        .then(response => {
          this.storesData.unshift(response.data.data)
        })
    },
    fetchData() {
      store.dispatch('app-product/fetchStores', {})
        .then(response => {
          this.dataFetched = true
          this.storesData = response.data.data
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.blankStoreData.value = undefined
          }
        })
    },
    resetstoreData() {
      this.storeData = JSON.parse(JSON.stringify(this.blankStoreData))
    },
  },
  // eslint-disable-next-line no-unused-vars
  setup(props, { emit }) {
    const onSubmit = () => {
    }
    const resetstoreData = () => {
      this.storeData.value = JSON.parse(JSON.stringify(this.blankStoreData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetstoreData)

    return {
      onSubmit,
      priceInputConfig: {
        numeralDecimalScale: 2,
        numeral: true,
      },
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
